import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelButton from '../atoms/CancelButton';
import DeleteButton from '../atoms/DeleteButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    openRemove,
    updateOpenRemove,
    cancelAction,
    removeAction,
    target,
    removeMessage
  }) => {
    return (
      <Dialog
        open={openRemove}
        onClose={() => {
          updateOpenRemove(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {removeMessage ? (
            <DialogContentText id="alert-dialog-description">
              {removeMessage}
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              {target}
              このメニューをこどもごちめしから解除しますか？
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <DeleteButton onClickAction={removeAction} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
